module.exports = __webpack_public_path__ + "static/media/so-stock--chicken4.bfeeb073.jpg";